<lms-breadcrumb></lms-breadcrumb>

<lms-toolbar [options]="toolbarConfig">
  <div class="lms-toolbar__item" *lmsProfileGuard="'agents.create'" tools-actions>
    <gl-button
      color-primary
      title="{{ 'agents.create' | translate }}"
      [text]="'agents.create' | translate"
      [routerLink]="['/agents/new']"
    ></gl-button>
  </div>
</lms-toolbar>

<lms-list-filters
  #filters
  [listId]="listId"
  [filtersService]="agentsFilters"
  [options]="filterOptions"
></lms-list-filters>

<lms-agents-list [listId]="listId"></lms-agents-list>
